export const GATEWAY_URL = `https://${process.env.NEXT_PUBLIC_PROFILES_GATEWAY_DOMAIN_NAME}`;
// export const GATEWAY_URL = `http://0.0.0.0:3001/profiles`;
